// Restaurant-operational language for Bills-native line states. Never show backend codes.
const UNIT_WORDS = { pcs: "pieces", gm: "grams", ml: "ml", kg: "kg", l: "litres" };

export const unitWord = (u) => UNIT_WORDS[u] || u || "";

export const fmtQty = (n) =>
  n == null ? "" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 3 });

export const fmtMoney = (n, cur = "INR") =>
  n == null ? "—" : Number(n).toLocaleString("en-IN", { style: "currency", currency: cur || "INR", maximumFractionDigits: 2 });

// One of: NEEDS_INGREDIENT | NEEDS_DETAIL | CHECK_PACK | UNIT_MISMATCH | RECHECK | READY
export function lineState(line, gateLine) {
  const blockers = gateLine?.blockers || [];
  if (gateLine?.eligible) return "READY";
  if (!line.resolved_ingredient_id || blockers.some((b) => b.startsWith("INGREDIENT_") && b !== "INGREDIENT_BASE_UOM_MISMATCH"))
    return "NEEDS_INGREDIENT";
  if (blockers.includes("STALE_CONVERSION_EVIDENCE") || blockers.includes("INGREDIENT_BASE_UOM_MISMATCH")) return "RECHECK";
  if (line.decision === "SUGGESTED_CONVERSION") return "CHECK_PACK";
  if (line.decision === "INVALID_CONVERSION") return "UNIT_MISMATCH";
  return "NEEDS_DETAIL";
}

export const STATE_LABEL = {
  READY: "Ready",
  NEEDS_INGREDIENT: "Ingredient needed",
  NEEDS_DETAIL: "Needs one detail",
  CHECK_PACK: "Check the pack size",
  UNIT_MISMATCH: "This unit doesn't match the ingredient",
  RECHECK: "Something changed — please check again",
};

export function questionFor(line) {
  const base = line.target_base_uom;
  const unit = line.raw_unit || "unit";
  if (line.decision === "INVALID_CONVERSION") return `Tell us what's inside one ${unit} (in ${unitWord(base)})`;
  if (base === "pcs") return `How many pieces are in one ${unit}?`;
  return `How many ${unitWord(base)} are in one ${unit}?`;
}

// "Coke Can 24 x 330 ml" → "24 cans × 330 ml" (display only; the backend suggestion is the authority).
export function packText(suggestion) {
  const m = /(\d+)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*([a-z]+)/i.exec(suggestion?.text || "");
  if (!m) return null;
  const noun = /\bcan/i.test(suggestion.text) ? "cans" : /\bbottle/i.test(suggestion.text) ? "bottles" : "units";
  return `${m[1]} ${noun} × ${m[2]} ${m[3].toLowerCase()}`;
}

export const CONFIRM_ERRORS = {
  financial_evidence_incomplete: "This bill prints tax, but its taxable (pre-tax) value isn't recorded. Enter the printed Taxable / Subtotal amount, then confirm.",
  financial_snapshot_unreconciled: "The printed subtotal, tax and total on this bill don't add up. Check the amounts.",
  unclassified_charge_requires_decision: "One of the printed charges still needs to be classified before this bill can be confirmed.",
  total_amount_required: "Enter the bill total before confirming.",
  bill_date_required: "Enter the bill date before confirming.",
  native_vendor_not_resolvable: "This vendor isn't set up for Bills yet. Ask your admin to add the vendor, then try again.",
  TAX_TOTALS_REJECTED: "The bill totals don't add up. Check the amounts on the bill.",
  invalid_numeric: "One of the amounts or tax values isn't a valid number.",
  TOTALS_MISMATCH: "The bill totals don't add up. Check the amounts on the bill.",
  stale_conversion_evidence: "Something on this bill changed while you were reviewing it. Please check the highlighted item.",
  conversion_evidence_mismatch: "Something on this bill changed while you were reviewing it. Please check the highlighted item.",
  conversion_blocked: "Some items still need information.",
  retryable_technical_failure: "We couldn't confirm right now. Please try again in a moment.",
  bills_native_unavailable: "Bill review is temporarily unavailable. Please try again shortly.",
  not_draft: "This bill was already confirmed.",
  vendor_identity_resolution_required: "Please choose the vendor for this bill before confirming.",
  vendor_changed_reload: "The vendor on this bill was just changed. Please check it and confirm again.",
  gstin_registered_to_existing_vendor: "That GSTIN already belongs to a vendor in your list. Choose that vendor instead.",
  corrected_evidence_required: "Enter the corrected vendor name or GSTIN.",
  vendor_not_found: "That vendor isn't available. Please pick another.",
};
